import PasswordTextValidator from './PasswordTextValidator'
export default PasswordTextValidator
